import { CSSProperties, PropsWithChildren, ReactNode } from "react";
import {
  Modal as KitModal,
  ModalContentBody,
  ModalContentHead,
  ModalContentWrapper,
  ModalFooter,
} from "@kitbird/core";

interface ModalI extends PropsWithChildren {
  isOpen: boolean,
  setOpen: React.Dispatch<React.SetStateAction<boolean>> | ((modalState: boolean) => void),
  title: string,
  body: ReactNode | string,
  footer?: ReactNode | string,
  width?: number
  styleBody?: CSSProperties
}

const Modal = ({
  isOpen = true,
  setOpen,
  title,
  body,
  footer,
  width,
  styleBody,
}: ModalI) => (
  <KitModal open={isOpen} onClose={() => setOpen(false)} width={width || 580}>
    <ModalContentWrapper>
      <ModalContentHead title={title} onClose={() => setOpen(false)} />
      <ModalContentBody
        style={styleBody}
      >
        {body}
      </ModalContentBody>
      {
        footer
        && <ModalFooter>
          {footer}
        </ModalFooter>
      }
    </ModalContentWrapper>
  </KitModal>
);

export default Modal;
